module.exports = __webpack_public_path__ + "img/text.35777870.png";